module.exports = __webpack_public_path__ + "img/no-smoking.c51f7b2c.png";